import './css/Mensajes.css';
import { useEffect, useState } from "react";
import axios from 'axios';
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config';
import EmojiTextarea from './EmojiTextarea';

const URL_USUARIOS = `${CONFIG.API_URL}/operarTablaUsuario.php`;

function MensajesCrudForm({ enviarFormData, respuesta_a, para_r, asunto_r, llamoNuevo, cerrarModal, textareaRef }) {
    const [de, setDe] = useState("");
    const [para, setPara] = useState(para_r);
    const [asunto, setAsunto] = useState(asunto_r);
    const [mensaje, setMensaje] = useState("");
    const [files, setFiles] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [sugerencias, setSugerencias] = useState([]);
    const [habilitaEnvio, setHabilitaEnvio] = useState(false);
    const loggeduserRolId = localStorage.getItem('loggeduserRolId');

    useEffect(() => {
        setDe(JSON.parse(localStorage.getItem('loggeddatosuser')).usuario);
        obtenerUsuariosPermitidos(loggeduserRolId);
    }, []);
    
    const obtenerUsuariosPermitidos = (rol_origen) =>{
        axios.get(`${URL_USUARIOS}?rol_origen=${rol_origen}`)
            .then(res => { setUsuarios(res.data); console.log('usuariosPermitidos:',res.data);})
            .catch(err => { console.error("Error al obtener usuarios:", err); });
    }
    
    useEffect(() => {
        const termino = para.split(',').slice(-1)[0].trim();

        if (termino.length >= 2) {

            const texto = normalizarTexto(termino);

            const filteredUsers = usuarios.filter(usuario =>
                normalizarTexto(
                    `${usuario.nombre} ${usuario.apellido} ${usuario.usuario} ${usuario.roles || ''}`
                ).includes(texto)
            );

            setSugerencias(filteredUsers);
        } else {
            setSugerencias([]);
        }
    }, [para, usuarios]);

    const seleccionarUsuario = (usuario) => {
        const nuevosPara = para.split(',').slice(0, -1).concat(`${usuario.usuario} <<${usuario.nombre} ${usuario.apellido}>>,`).join(', ');
        setPara(nuevosPara);
        setHabilitaEnvio(true);
        setSugerencias([]);
    };

    function handleSubmint(e) {
        e.preventDefault();
        if (!para || !asunto || !mensaje) {
            show_alerta('Faltan datos', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('respuesta_a', respuesta_a);
        formData.append('de', de);
        formData.append('para', para);
        formData.append('asunto', asunto);
        formData.append('mensaje', mensaje);

        files.forEach((file, index) => {
            formData.append(`file${index}`, file);
        });

        enviarFormData(formData);
        handleReset();
    }

    const handleReset = () => {
        setPara("");
        setAsunto("");
        setMensaje("");
        setFiles([]);
    }

    const handleCerrar = () => {
        if (llamoNuevo) {
            cerrarModal();
        } else {
            cerrarModal(false);
        }
    };

    const normalizarTexto = (texto) => {
        return (texto || "")
            .toLowerCase()
            .normalize("NFD") // separa letras de acentos
            .replace(/[\u0300-\u036f]/g, ""); // elimina acentos
    };
    
    return (
    <div className="me-2">  
        <form onSubmit={handleSubmint} id='form'>
            <input type="hidden" name="respuesta_a" value={respuesta_a} />
            {llamoNuevo? 
            <>
                {/*si es mensaje directo nuevo */}
                {para_r==''?
                <>
                {/* Campo de texto para ingresar destinatario solo si es mensaje nuevo sin destinatario predefinido */}
                    <div className='input-group input-group-sm mb-3'>
                        <span className='input-group-text' id='inputGroup-sizing-sm'>Para</span>
                        <input
                        type="text"
                        className="form-control bg-light"
                        name="para"
                        placeholder="Destinatario"
                        autoComplete="off"
                        value={para}
                        onChange={(e) => setPara(e.target.value)}
                        aria-label="Sizing example input" 
                        aria-describedby="inputGroup-sizing-sm"
                        />
                    </div>
                </>
                :
                <>
                    <input
                        type="hidden"
                        className="form-control bg-light"
                        name="para"
                        placeholder="Destinatario"
                        autoComplete="off"
                        value={para}
                        onChange={(e) => setPara(e.target.value)}
                        aria-label="Sizing example input" 
                        aria-describedby="inputGroup-sizing-sm"
                    />
                </>
                }
                
                {sugerencias.length > 0 && (
                    <ul className="lista-sugerencias">
                        {sugerencias.map(usuario => (
                            <li key={usuario.usuario} onClick={() => seleccionarUsuario(usuario)}>
                                {usuario.nombre} {usuario.apellido} 
                                <small style={{color: '#666'}}> ({usuario.roles})</small>
                            </li>
                        ))}
                    </ul>
                )}
                {para}
                <div className='input-group m-1'>
                    <span className='input-group-text small'>Asunto</span>
                    <input
                        type="text"
                        className="form-control bg-light"
                        name="asunto"
                        onChange={(e) => setAsunto(e.target.value)}
                        value={asunto}
                    />
                </div>
            </>
            : 
            <>
            {/*Si es respuesta a mensaje, los campos para y asunto vienen ocultos pero con valor para enviar */}
                <input type="hidden" name="para" value={para} />
                <input type="hidden" name="asunto" value={asunto} />
            </>
            }
            {/* NUEVO TEXTAREA CON EMOJIS */}
            
            <EmojiTextarea
                value={mensaje}
                onChange={setMensaje}
                rows={(llamoNuevo && para_r=='')?8:respuesta_a==0?1:8} // si es mensaje nuevo sin destinatario predefinido, textarea grande. Si es respuesta, una linea solo si no es respuesta a mensaje (respuesta_a==0), sino grande
                placeholder="Mensaje aquí"
                name="mensaje"
            />

            <label className="btn btn-light  p-2 mb-0">
                 <i className="fa-solid fa-paperclip"></i>{files.length > 0 ? `Archivos: ${files.length}` : ''}
                <input
                    type="file"
                    name="file"
                    multiple
                    onChange={(e) => {
                        const archivos = [...e.target.files];
                        setFiles(archivos);
                        console.log("Archivos:", archivos.length);
                    }}
                    hidden
                />
            </label>
            <button 
            className="btn btn-success m-1" 
            type="submit" 
            disabled={(!habilitaEnvio && !respuesta_a && !para_r)}
            >
                 <i className="fa-solid fa-paper-plane"></i>
            </button> 
            {/*si es grupal no muestro boton limpiar porque no tiene sentido limpiar el destinatario */}
            {(llamoNuevo && para_r=='')&& (
                <input
                    className="btn btn-warning m-1"
                    type="reset"
                    value="Limpiar"
                    onClick={handleReset}
            />
            )}
          <button
                type="button"
                id="btnCerrar"
                className="btn btn-secondary"
                onClick={handleCerrar}
            >
                X
            </button>
           
            </form>
        </div>
    )
}

export default MensajesCrudForm;
